<template>
  <div>
    <v-dialog v-model="dialog" max-width="800">
      <template v-slot:activator="{ on, attrs }">
        <mf-icon v-bind="attrs" color="primary" v-on="on">settings</mf-icon>
      </template>
      <v-card>
        <v-card-title>
          <span class="section-title">Configurar URLs</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="mb-0 py-0">
              <label class="detail-title">URLs de produção</label>
              <v-text-field v-model="url" class="mb-0" outlined prefix="https://" :hide-details="!urlError" :error="!!urlError" :error-messages="urlError">
                <template v-slot:append-outer>
                  <mf-icon v-if="!loading" style="cursor: pointer" :disabled="!urlIsValid" color="primary" @click="addUrl">add</mf-icon>
                  <v-progress-circular v-else :size="24" indeterminate color="primary"></v-progress-circular>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="mb-0 py-0">
              <v-chip-group active-class="primary--text">
                <v-chip
                  v-for="(url, index) in internalValue"
                  :key="index"
                  v-clipboard="() => url"
                  close
                  :ripple="false"
                  class="copy-button"
                  @click:close="removeUrl(index)"
                  @click="() => $snackbar({ message: 'Copiado para área de transferencia.' })"
                >
                  <span>{{ url }}</span>
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <mf-button class="mr-3" outlined label="Cancelar" :disabled="loading" tooltip="teste" @click="dialog = false" />
          <mf-button :loading="loading" label="Salvar" @click="saveUrls" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import cloneDeep from 'lodash/cloneDeep'
import { QUERY_URL_IS_AVAILABLE } from '@/modules/configuracoes-admin/graphql'
export default {
  props: {
    value: Array,
    saveFn: Function,
  },
  data: () => ({
    lazyValue: [],
    url: '',
    loading: false,
    dialog: false,
  }),
  computed: {
    internalValue: {
      get() {
        return this.lazyValue
      },
      set(value) {
        this.lazyValue = value
        this.$emit('input', value)
      },
    },
    urlIsValid() {
      if (!this.url) return true
      return (
        /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/i.test(this.url) &&
        !this.internalValue.includes(this.url) &&
        !/\s/.test(this.url)
      )
    },
    urlError() {
      if (this.$v.url.$error) return 'Antes de salvar, clique no + caso queira adicionar a URL. Caso não queira adicionar esta URL, limpe o campo.'
      if (!this.urlIsValid) return 'URL inválida'
      return ''
    },
  },
  mounted() {
    this.lazyValue = this.value
  },
  methods: {
    async saveUrls() {
      this.$v.$touch()
      if (this.$v.$error) return
      this.loading = true
      try {
        await this.saveFn(this.internalValue)
      } catch (e) {
        this.$snackbar({ message: 'Falha ao salvar URLs.' })
      } finally {
        this.loading = false
      }
      this.dialog = false
    },
    removeUrl(index) {
      const urls = cloneDeep(this.internalValue)
      urls.splice(index, 1)
      this.internalValue = urls
    },
    async addUrl() {
      if (!this.url) return
      if (!this.urlIsValid) return
      let result
      this.loading = true
      try {
        result = await this.$apollo.query({
          query: QUERY_URL_IS_AVAILABLE,
          fetchPolicy: 'network-only',
          variables: {
            url: this.url,
          },
        })
      } catch (e) {
        this.$snackbar({ message: 'Falha ao validar URL.' })
        this.loading = false
        return
      }

      this.loading = false
      if (result.data.urlIsAvailable) {
        const urls = cloneDeep(this.internalValue)
        urls.push(this.url)
        this.internalValue = urls
        Swal.fire({
          text: 'URL disponível',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        })
      } else {
        Swal.fire({
          text: 'URL indisponível',
          icon: 'error',
        })
      }
      this.url = ''
    },
  },
  validations() {
    return {
      url: {
        mustBeEmpty: (value) => !value || value.length === 0,
      },
    }
  },
}
</script>
